import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '../components/Layout'
import { getHistory, clearHistory as clearHistoryUtil, HistoryItem } from '../utils/history'

function History() {
  const { t } = useTranslation()
  const [history, setHistory] = useState<HistoryItem[]>([])

  useEffect(() => {
    setHistory(getHistory())
  }, [])

  const handleClearHistory = () => {
    clearHistoryUtil()
    setHistory([])
  }

  const formatDate = (timestamp: number) => {
    return new Date(timestamp).toLocaleString()
  }

  const truncate = (text: string, maxLength: number = 50) => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
  }

  return (
    <Layout>
      <div className="flex flex-col p-4 gap-4">
        <div className="flex items-center justify-between">
          <h2 className="text-slate-900 dark:text-white text-xl font-bold">{t('history.title')}</h2>
          {history.length > 0 && (
            <button 
              onClick={handleClearHistory}
              className="text-sm text-red-500 hover:text-red-600 transition-colors flex items-center gap-1"
            >
              <span className="material-symbols-outlined text-[18px]">delete</span>
              {t('history.clearAll')}
            </button>
          )}
        </div>

        {history.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-surface-dark flex items-center justify-center mb-4">
              <span className="material-symbols-outlined text-4xl text-slate-400">history</span>
            </div>
            <h3 className="text-slate-900 dark:text-white font-semibold text-lg mb-2">{t('history.noHistory')}</h3>
            <p className="text-slate-500 dark:text-slate-400 text-sm max-w-[250px]">
              {t('history.noHistoryDescription')}
            </p>
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {history.map((item) => (
              <div 
                key={item.id}
                className="bg-white dark:bg-surface-dark rounded-xl p-4 border border-slate-200 dark:border-slate-800"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs font-semibold text-primary uppercase tracking-wider">
                    {item.toolName || item.tool}
                  </span>
                  <span className="text-xs text-slate-400">
                    {formatDate(item.timestamp)}
                  </span>
                </div>
                <div className="space-y-2">
                  <div>
                    <span className="text-xs text-slate-500 dark:text-slate-400">{t('history.input')}:</span>
                    <p className="text-sm text-slate-700 dark:text-slate-300 font-mono truncate">
                      {truncate(item.input)}
                    </p>
                  </div>
                  <div>
                    <span className="text-xs text-slate-500 dark:text-slate-400">{t('history.output')}:</span>
                    <p className="text-sm text-slate-700 dark:text-slate-300 font-mono truncate">
                      {truncate(item.output)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  )
}

export default History
